export class Pagination {
  allowedRanges: Array<{ range: any }>;
  maxPaginationItems: number;
  directionLinks: boolean;
  boundaryLinks: boolean;
  ellipses: boolean;
  rotate: boolean;
  size: 'sm' | 'ls';
  page: number;
  pagesize: any;
  sort: string;
  direction: string;
  userid: number;

  constructor(pagination: any) {
    this.allowedRanges = pagination.allowedRanges;
    this.maxPaginationItems = pagination.maxPaginationItems || 3;
    this.directionLinks = pagination.directionLinks || true;
    this.boundaryLinks = pagination.boundaryLinks || false;
    this.ellipses = pagination.ellipses || true;
    this.rotate = pagination.rotate || true;

    this.size = pagination.size;
    this.page = pagination.page || 1;
    this.pagesize = pagination.pagesize || this.allowedRanges[0].range;
    this.sort = pagination.sort || '';
    this.direction = pagination.direction || 'ASC';
  }
}

